import { autoinject, PLATFORM, useView } from "aurelia-framework";
import { MyVesselService } from "../../../services/my-vessel.service";
import { VesselModel } from "../../../models/myvessels.models";
import { NotificationClientService, NotificationType } from "@rightship-tech/common-ui/services/basic/notification-client.service";
import { Router } from "aurelia-router";
import { DocumentManagementRoutes } from "@rightship-tech/document-management-app/constants/route.constant";

@autoinject
@useView(PLATFORM.moduleName("./vessel-documents.html"))
export class VesselDocuments 
{
    public vesselId: number;
    public vessel: VesselModel;

    constructor(private myVesselService: MyVesselService, private notificationService: NotificationClientService, private router: Router) {}

    activate(params: { vesselId: number }) {
        this.vesselId = params.vesselId;
    }

    async attached() {

        //Get vessel details
        await this.getVessel(this.vesselId);
    }
    
    //Check if the user can navigate back
    public canNavigateBack(): boolean {
		return this.router.history && this.router.history.getHistoryIndex() > 0;
	}

    //Get vessel details
    public async getVessel(vesselId: number)
    {
        try {            
            this.vessel = await this.myVesselService.getVessel(vesselId);
        } catch (error) {
            console.error(error);
            this.notificationService.show("Error", "An error occurred while getting vessel details.", NotificationType.Error);
        }
    }

    //Navigate back
    public navigateBack()
    {
        this.router.navigateBack();
    }
    
    //Navigate to manage document requirements
    public navigateToManageDocumentRequirements() {
		this.router.navigateToRoute(DocumentManagementRoutes.ManageDocumentRequirements);
    }
}